var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrahsPopover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.70833H23.375V3.83333C23.375 3.31395 23.1687 2.81584 22.8014 2.44858C22.4341 2.08132 21.936 1.875 21.4166 1.875H13.5833C13.0639 1.875 12.5658 2.08132 12.1986 2.44858C11.8313 2.81584 11.625 3.31395 11.625 3.83333V9.70833Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.70833H3.79165L5.74998 33.2083C5.74998 34.2471 6.16263 35.2433 6.89714 35.9778C7.63166 36.7124 8.62788 37.125 9.66665 37.125H25.3333C26.3721 37.125 27.3683 36.7124 28.1028 35.9778C28.8373 35.2433 29.25 34.2471 29.25 33.2083L31.2083 9.70833H23.375H11.625Z",
    fill: "#D9E2DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83331 9.70833H33.1666M13.5833 17.5417V29.2917M21.4166 17.5417V29.2917M11.625 9.70833V3.83333C11.625 3.31395 11.8313 2.81584 12.1986 2.44858C12.5658 2.08132 13.0639 1.875 13.5833 1.875H21.4166C21.936 1.875 22.4341 2.08132 22.8014 2.44858C23.1687 2.81584 23.375 3.31395 23.375 3.83333V9.70833M11.625 9.70833H23.375M11.625 9.70833H3.79165L5.74998 33.2083C5.74998 34.2471 6.16263 35.2433 6.89714 35.9778C7.63166 36.7124 8.62788 37.125 9.66665 37.125H25.3333C26.3721 37.125 27.3683 36.7124 28.1028 35.9778C28.8373 35.2433 29.25 34.2471 29.25 33.2083L31.2083 9.70833H23.375",
    stroke: "#1E5A5B",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrahsPopover);
export default __webpack_public_path__ + "static/media/trahsPopover.c36a1ca41d1d49174f58eb6fa41d76eb.svg";
export { ForwardRef as ReactComponent };